'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { LucideCircleCheck } from 'lucide-react';

export function AddReviewSuccess() {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-4 bg-white py-8',
        'ea-add-review-success',
      )}
    >
      <LucideCircleCheck size={56} className="text-primary" />
      <Heading title={t('text648')} center />
      <Paragraph size="lg" className="text-center text-muted-foreground">
        {t('text661')}
      </Paragraph>
    </div>
  );
}
